import { useMeStore } from "@/features/auth/hooks/useCurrentUser"

/**
 * The largest file the server takes, as /me reports it (max_file_bytes); the client's own constant
 * when /me does not say. Client caps read this so they match the server's limit.
 */
export function maxFileBytes(fallback: number): number {
  try {
    const v = useMeStore.getState().me?.max_file_bytes
    return typeof v === "number" && v > 0 ? v : fallback
  } catch {
    return fallback
  }
}

/** "50 MB" for a byte limit, rounded to whole megabytes (at least one). */
export function megabytesLabel(bytes: number): string {
  return `${Math.max(1, Math.round(bytes / (1024 * 1024)))} MB`
}
